import * as BaseAPI from '@/api/baseAPI';

export async function getUser(): Promise<any> {
  const http = await BaseAPI.createHttpRequest();

  const result = await http.get('/user');

  return result.data;
}
